import { render, staticRenderFns } from "./China.vue?vue&type=template&id=e9cdbb58"
import script from "./China.vue?vue&type=script&lang=js"
export * from "./China.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports